module.exports = __webpack_public_path__ + "static/media/sample_vin_rail_bulk_force_close.a3009155.csv";